import React from "react";
import { useTranslation } from "react-i18next";
import { useGlobalState } from "senf-shared";
import { cn } from "../../../util/classNameConstructor";
import Skeleton from "../../atoms/skeleton/Skeleton";
import Icon from "../../core/icon/Icon";

const IdeaCardHeader = ({ data, maxWidth, className }) => {
  const { t } = useTranslation();
  const [translation] = useGlobalState().translationsState;

  return (
    <div className={cn("flex items-center gap-2 justify-start", className)}>
      {data?.topic ? (
        <Icon
          name={data.geoDataType === "noLocation" ? "pin-strikethrough" : "pin"}
          color={data.color}
          className="shrink-0"
        />
      ) : (
        <Skeleton round width={16} square className="max-w-min" />
      )}

      <div className="flex flex-col gap-1 body-sm">
        {data?.title ? (
          <span
            className={cn(
              "text-text-default line-clamp-1 break-all text-start font-semibold",
              maxWidth && `max-w-[${maxWidth}]`,
            )}
          >
            {translation?.[data.topicLabel] || data.topicLabel}
          </span>
        ) : (
          <Skeleton />
        )}

        {data?.geoDataType ? (
          <span
            className={cn(
              "body-smtext-text-subdued -mt-1 line-clamp-1 break-all",
              maxWidth && `max-w-[${maxWidth}]`,
            )}
          >
            {data?.geoDataType === "noLocation"
              ? t("global:noLocationLocationHeader")
              : data?.geoDataType === "path"
                ? t("global:path")
                : data?.geoDataType === "area"
                  ? t("global:area")
                  : `${data?.address}${
                      data?.localityName ? `, ${data?.localityName}` : ""
                    }`}
          </span>
        ) : (
          <Skeleton />
        )}
      </div>
    </div>
  );
};

export default IdeaCardHeader;
